import type { Analytics } from '@melio/platform-analytics';

// Segment write key for the developers portal source. A browser write key is public by design —
// it ships in the bundle, same as the FullStory org id.
const SEGMENT_KEY = 'EJ3N2VRhwnd0eFx5CFt1BobojP0OF4GS';

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

declare global {
  interface Window {
    dynamicEnvConfig?: Partial<Config>;
  }
}

export interface Config {
  version: string;
  sentryDsn: string;
  fullStoryOrgId: string;
  production: boolean;
  environment: string;
  consoleLogsEnabled: boolean;
  analytics: Parameters<(typeof Analytics)['init']>[0];
  dataDog: {
    shouldInit: boolean;
    appId: string;
    clientId: string;
    site: string;
    service: string;
  };
}

const defaultConfig: Config = {
  environment: 'development',
  version: '1.0.0',
  production: false,
  sentryDsn: '',
  fullStoryOrgId: '10BZN1',
  consoleLogsEnabled: true,
  analytics: {
    // Locally events are only printed to the console — nothing is sent to Segment.
    reportEvents: false,
    printEvents: true,
    segmentKey: SEGMENT_KEY,
  },
  dataDog: {
    shouldInit: false,
    appId: '<your-datadog-app-id>',
    clientId: '<your-datadog-client-id>',
    site: 'datadoghq.com',
    service: 'developers-portal',
  },
};

const getEnvConfig = (env: string): Partial<Config> => {
  // Development - use default
  if (env === 'development') {
    return {};
  }

  // Production
  if (env === 'production') {
    return {
      consoleLogsEnabled: false,
      analytics: {
        reportEvents: true,
        printEvents: false,
        segmentKey: SEGMENT_KEY,
      },
      dataDog: {
        shouldInit: true,
        appId: '<your-datadog-app-id>',
        clientId: '<your-datadog-client-id>',
        site: 'datadoghq.com',
        service: 'developers-portal',
      },
    };
  }

  // Non-prod environments (eilat, staging01, int02, etc.)
  return {
    analytics: {
      reportEvents: true,
      printEvents: true,
      segmentKey: SEGMENT_KEY,
    },
    dataDog: {
      shouldInit: true,
      appId: '<your-datadog-app-id>',
      clientId: '<your-datadog-client-id>',
      site: 'datadoghq.com',
      service: 'developers-portal',
    },
  };
};

const baseConfig: Config = { ...defaultConfig, ...window.dynamicEnvConfig };
const envConfig = getEnvConfig(baseConfig.environment);

export const config: Config = { ...baseConfig, ...envConfig };
